import { useContext } from "react";

import { EvaluationUpdateFormContext } from "../../components/EvaluationUpdateForm/contexts/EvaluationUpdateForm/EvaluationUpdateFormContext";

export function useEvaluationUpdateForm() {
  const context = useContext(EvaluationUpdateFormContext);

  if (!context) {
    throw new Error(
      "useEvaluationUpdateForm should be used within the EvaluationUpdateFormProvider provider."
    );
  }

  return context;
}
